import { render, staticRenderFns } from "./BackOptions.vue?vue&type=template&id=cfb0b086&scoped=true&"
import script from "./BackOptions.vue?vue&type=script&lang=js&"
export * from "./BackOptions.vue?vue&type=script&lang=js&"
import style0 from "./BackOptions.vue?vue&type=style&index=0&id=cfb0b086&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0b086",
  null
  
)

export default component.exports